import { type FC } from 'react'
import styled from 'styled-components'
import { badgeColors, colors } from 'theme'

import { Badge as BadgeType } from '../../types/graphql'
const labels: Record<BadgeType, string> = {
  BRONZE: 'Bronze',
  SILVER: 'Argent',
  GOLDEN: 'Or',
  PLATINUM: 'Platine',
  DIAMOND: 'Diamant',
  TITANIUM: 'Titane',
  QUARTZ: 'Quartz',
  ADAMANTIUM: 'Adamantium',
  SAPPHIRE: 'Saphir',
  RUBY: 'Rubis',
  EMERALD: 'Émeraude',
  OBSIDIAN: 'Obsidienne',
  MITHRIL: 'Mithril',
  AETHER: 'Éther',
  AGATE: 'Agate',
  AMBER: 'Ambre',
  AMETHYST: 'Amethyste',
  GARNET: 'Grenat',
  IRIDIUM: 'Iridium',
  IRON: 'Fer',
  JADE: 'Jade',
  METEORITE: 'Météorite',
  NEBULA: 'Nébuleuse',
  OPAL: 'Opale',
  ORICHALCUM: 'Orichalque',
  RHODIUM: 'Rhodium',
  SPINEL: 'Spinelle',
  STEEL: 'Acier',
  TOPAZ: 'Topaze',
  TUNGSTEN: 'Tungstène',
}

type Props = {
  type: BadgeType
}

const Badge: FC<Props> = ({ type }) => {
  if (type === null) {
    return <None>-</None>
  }

  return (
    <StyledBadge $type={type}>
      {labels[type]}
    </StyledBadge>
  )
}

const resolveColor = (type: BadgeType) => {
  if ([
    BadgeType.BRONZE,
    BadgeType.STEEL,
    BadgeType.PLATINUM,
    BadgeType.TUNGSTEN,
    BadgeType.IRIDIUM,
    BadgeType.GARNET,
    BadgeType.SPINEL,
    BadgeType.SAPPHIRE,
    BadgeType.RUBY,
    BadgeType.OBSIDIAN,
    BadgeType.METEORITE,
    BadgeType.NEBULA,
  ].includes(type)) {
    return colors.white
  }

  return colors.black
}

const resolveBackgroundColor = (type: BadgeType) => {
  switch (type) {
    case BadgeType.BRONZE:
      return badgeColors.bronze
    case BadgeType.IRON:
      return badgeColors.iron
    case BadgeType.STEEL:
      return badgeColors.steel
    case BadgeType.SILVER:
      return badgeColors.silver
    case BadgeType.QUARTZ:
      return badgeColors.quartz
    case BadgeType.OPAL:
      return badgeColors.opal
    case BadgeType.AGATE:
      return badgeColors.agate
    case BadgeType.JADE:
      return badgeColors.jade
    case BadgeType.AMBER:
      return badgeColors.amber
    case BadgeType.GOLDEN:
      return badgeColors.gold
    case BadgeType.PLATINUM:
      return badgeColors.platinum
    case BadgeType.TITANIUM:
      return badgeColors.titanium
    case BadgeType.TUNGSTEN:
      return badgeColors.tungsten
    case BadgeType.RHODIUM:
      return badgeColors.rhodium
    case BadgeType.IRIDIUM:
      return badgeColors.iridium
    case BadgeType.TOPAZ:
      return badgeColors.topaz
    case BadgeType.GARNET:
      return badgeColors.garnet
    case BadgeType.AMETHYST:
      return badgeColors.amethyst
    case BadgeType.SPINEL:
      return badgeColors.spinel
    case BadgeType.SAPPHIRE:
      return badgeColors.sapphire
    case BadgeType.EMERALD:
      return badgeColors.emerald
    case BadgeType.RUBY:
      return badgeColors.ruby
    case BadgeType.DIAMOND:
      return badgeColors.diamond
    case BadgeType.OBSIDIAN:
      return badgeColors.obsidian
    case BadgeType.METEORITE:
      return badgeColors.meteorite
    case BadgeType.ADAMANTIUM:
      return badgeColors.adamantium
    case BadgeType.MITHRIL:
      return badgeColors.mithril
    case BadgeType.ORICHALCUM:
      return badgeColors.orichalcum
    case BadgeType.NEBULA:
      return badgeColors.nebula
    case BadgeType.AETHER:
      return badgeColors.aether
    default:
      return colors.blueGray
  }
}

const StyledBadge = styled('span') <{ $type: BadgeType }>`
  display: inline-block;
  width: fit-content;
  padding: 6px 7px;
  font-family: Montserrat;
  font-size: 0.75rem;
  font-weight: 600;
  color: ${({ $type }) => resolveColor($type)};
  text-transform: uppercase;
  background-color: ${({ $type }) => resolveBackgroundColor($type)};
  border-radius: 8px;
`

const None = styled.span`
  font-family: 'brother-1816';
  font-weight: 700;
  color: ${colors.blueGray};
`

export default Badge
